import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from 'app/baseQuery';
import { apiTags } from 'app/store/apiTags';

const apiPrefix = 'vendorInvoice';

export const vendorInvoiceApi = createApi({
    reducerPath: 'vendorInvoiceApi',
    baseQuery: baseQuery,
    endpoints: (builder) => ({
        getVendorInvoices: builder.query({
            query: (params = {}) => {
                let url = `${apiPrefix}`;
                if (params.includeHistory !== undefined) {
                    url += `?includeHistory=${params.includeHistory}`;
                }
                return url;
            },
            providesTags: [apiTags.VENDOR_INVOICES],
        }),
        addVendorInvoice: builder.mutation({
            query: (invoice) => ({
                url: `${apiPrefix}`,
                method: 'POST',
                body: invoice
            }),
            invalidatesTags: [apiTags.VENDOR_INVOICES],
        }),
        updateVendorInvoice: builder.mutation({
            query: (invoice) => ({
                url: `${apiPrefix}/update`,
                method: 'PUT',
                body: invoice
            }),
            invalidatesTags: [apiTags.VENDOR_INVOICES],
        }),
        updateVendorInvoiceStatus: builder.mutation({
            query: ({ id, statusId }) => ({
                url: `${apiPrefix}/updateStatus`,
                method: 'PUT',
                body: { id, status: statusId }
            }),
            invalidatesTags: [apiTags.VENDOR_INVOICES],
        }),
        deleteVendorInvoice: builder.mutation({
            query: (id) => ({
                url: `${apiPrefix}/delete`,
                method: 'PUT',
                body: { id }
            }),
            invalidatesTags: [apiTags.VENDOR_INVOICES],
        }),
        getMatchingWorkordersForInvoice: builder.query({
            query: (params) => {
                const queryString = Object.keys(params).map(param => {
                    if (Array.isArray(params[param])) {
                        return params[param].map(value => `${param}=${value}`).join('&');
                    } else {
                        return params[param] ? `${param}=${params[param]}` : undefined;
                    }
                }).filter(k => k).join('&');
                return `${apiPrefix}/matchingWorkorders?${queryString}`
            },
            providesTags: [apiTags.VENDOR_INVOICES],
        }),
        getAutoMatchingWorkordersForInvoice: builder.query({
            query: (params) => {
                const queryString = Object.keys(params).map(param => {
                    if (Array.isArray(params[param])) {
                        return params[param].map(value => `${param}=${value}`).join('&');
                    } else {
                        return params[param] ? `${param}=${params[param]}` : undefined;
                    }
                }).filter(k => k).join('&');
                return `${apiPrefix}/autoMatchingWorkorders?${queryString}`
            },
            providesTags: [apiTags.VENDOR_INVOICES],
        }),
    }),
});

export const {
    useGetVendorInvoicesQuery,
    useAddVendorInvoiceMutation,
    useUpdateVendorInvoiceMutation,
    useUpdateVendorInvoiceStatusMutation,
    useDeleteVendorInvoiceMutation,
    useGetMatchingWorkordersForInvoiceQuery,
    useGetAutoMatchingWorkordersForInvoiceQuery
} = vendorInvoiceApi;
